import React, { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Destinations from "@/components/Destinations";
import Packages from "@/components/Packages";
import BookingForm from "@/components/BookingForm";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import SEO from "@/components/SEO";

export default function Book() {


useEffect(() => {

 const schema_festival = { 
"@context": "https://schema.org",
"@type": "Event",
"name": "Paragliding demonstration with Tandem Paragliding Costa Rica",
"startDate": new Date().toISOString(),
"endDate": new Date(new Date().getTime() + 2 * 60 * 60 * 1000).toISOString(),
"eventAttendanceMode": "https://schema.org",
"eventStatus": "https://schema.org",
"location": [
  {
    "@type": "Place",
    "name": "Rivas Soccerfield Perez Zeledon",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rivas Soccerfield, Perez Zeledon",
      "addressLocality": "Perez Zeledon",
      "addressRegion": "San Jose",
      "postalCode": "11901",
      "addressCountry": "CR"
    }
  }
],
"image": [
  "https://static.wixstatic.com/media/c59e42_ee679c95568243718440c6c51bd21a97~mv2.jpeg/v1/fill/w_1280,h_720,al_c,q_85,enc_avif,quality_auto/c59e42_ee679c95568243718440c6c51bd21a97~mv2.jpeg"
],
"description": "The amazing paraglide tour in Costa Rica. Experience the thrill of tandem paragliding with our expert instructors. Book your adventure today!",
"offers": {
  "@type": "Offer",
  "url": "https://paraglidetour.com/#tours",
  "price": "110.00",
  "priceCurrency": "USD",
  "availability": "https://schema.org",
  "validFrom": "2026-01-01T00:00:00-04:00"
},
"performer": {
  "@type": "Organization",
  "name": "Tandem Paragliding Costa Rica",
  "url": "https://parapenteperezzeledon.com"
},
"organizer": {
  "@type": "Organization",
  "name": "Paraglide Tour Costa Rica",
  "url": "https://www.paraglidecostarica.com/"
}
};

//
const schema_event = {


  "@context": "https://schema.org",
  "@type": "SportsEvent",
  "name": "Mañana de parapente en Rivas",
  "description": "Manñana de vuelos en parapente sobre Rivas de Perez Zeledon con aterizajes suaves en parapente tandem",
  "startDate": new Date().toISOString(),
  "endDate": new Date(new Date().getTime() + 2 * 60 * 60 * 1000).toISOString(),
  "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
  "eventStatus": "https://schema.org/EventScheduled",
  "location": {
    "@type": "Place",
    "name": "Plaza de Futbol de Rivas",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rivas de Perez Zeledon",
      "addressLocality": "Perez Zeledon",
      "addressCountry": "Costa Rica"
    }
  },
  "organizer": {
    "@type": "Organization",
    "name": "Paraglide Costa Rica",
    "url": "https://www.paraglidecostarica.com/"
  },
  "performer": {
    "@type": "Person",
    "name": "Parapente Perez Zeledon"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://parapenteperezzeledon.com",
    "price": "110",
    "priceCurrency": "USD",
    "validFrom": "2026-01-01T08:44",
    "availability": "https://schema.org/InStock",
    "name": "Ticket - $110"
  },
  "image": "https://static.wixstatic.com/media/c59e42_ee679c95568243718440c6c51bd21a97~mv2.jpeg/v1/fill/w_1280,h_720,al_c,q_85,enc_avif,quality_auto/c59e42_ee679c95568243718440c6c51bd21a97~mv2.jpeg"
}
 
//paragliding course schema
const schema_course =
{
      "@context": "https://schema.org",
      "@type": "Course",
      "name": "Paraglider Training Course",
      "description": "Learn to paraglide with our comprehensive training course. Our experienced instructors will guide you through the fundamentals of paragliding, ensuring a safe and enjoyable learning experience.",
      "provider": {
        "@type": "Organization",
        "name": "Paraglide Costa Rica",
        "sameAs": "https://www.paraglidecostarica.com/"
      }
    }

const schema ={};
  schema.event=schema_festival;
  schema.sportsEvent=schema_event;
  schema.course=schema_course;


    // Inject the JSON-LD script into <head>, remove any prior one
    const id = "product-schema-json-ld";
    let script = document.getElementById(id);
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      document.head.appendChild(script);
    }
    //script.textContent = JSON.stringify(schema+schema_festival);
    script.textContent = JSON.stringify(schema);
    

}, []);


  return (
    <div data-testid="home-page" className="min-h-screen bg-sand text-jungle">
      <SEO />
      <Header />
      <main>
        <BookingForm />
        <Gallery />
        <Testimonials />
        <FAQSection />
        <Packages />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
